module.exports = __webpack_public_path__ + "static/img/homebg.0450e79.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/homebg.jpg
// module id = /Oqy
// module chunks = 1